import type { OpsRouteRun } from '../../types/route-run.type';
import type { SupplierCollectionPoint } from '../../types/supplier.type';

export const STOP_STATUS_COLOR: Record<string, 'default' | 'info' | 'success' | 'error'> = {
  pending: 'default',
  arrived: 'info',
  collected: 'success',
  cancelled: 'error',
};

/** The run's stops as map points, from the frozen snapshots (one per planned stop). */
export function stopsAsMapPoints(run: OpsRouteRun): SupplierCollectionPoint[] {
  return run.stops
    .map((stop) => stop.point_snapshot)
    .filter((snapshot) => Number.isFinite(snapshot?.latitude) && Number.isFinite(snapshot?.longitude))
    .map((snapshot, index) => ({
      id: `${snapshot.id}-${index}`,
      supplier_id: snapshot.supplier_id,
      name: snapshot.name,
      city: snapshot.city ?? null,
      address: snapshot.address ?? null,
      latitude: snapshot.latitude,
      longitude: snapshot.longitude,
    }) as unknown as SupplierCollectionPoint);
}

export function facilityMarker(snapshot: Record<string, any> | null | undefined) {
  if (!snapshot) return null;
  return { name: snapshot.name ?? '', latitude: snapshot.latitude ?? null, longitude: snapshot.longitude ?? null };
}

export function runTotals(run: OpsRouteRun) {
  const collected = run.stops.filter((stop) => stop.status === 'collected');
  return {
    collected: collected.length,
    cancelled: run.stops.filter((stop) => stop.status === 'cancelled').length,
    weightKg: collected.reduce((sum, stop) => sum + (stop.weight_kg ?? 0), 0),
    price: collected.reduce((sum, stop) => sum + (stop.price_amount ?? 0), 0),
  };
}
